import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";

const TrendDuration = ({ data = {} }) => {
  const { t } = useTranslation();

  const durationKeys = [
    "2hour",
    "3hour",
    "4hour",
    "5hour",
    "6hour",
    "12hour",
    "overnight",
    "unknown",
  ];

  const { categories, series, isEmpty } = useMemo(() => {
    const monthlyData = data?.monthlyData || [];

    const allZero =
      monthlyData.length === 0 ||
      monthlyData.every((m) => !m.total || m.total === 0);

    if (allZero) {
      return {
        categories: [
          t("months.jan"),
          t("months.feb"),
          t("months.mar"),
          t("months.apr"),
          t("months.may"),
          t("months.jun"),
          t("months.jul"),
          t("months.aug"),
          t("months.sep"),
          t("months.oct"),
          t("months.nov"),
          t("months.dec"),
        ],
        series: durationKeys.map((d) => ({
          name: t(`trendDuration.durations.${d}`),
          data: new Array(12).fill(0),
        })),
        isEmpty: true,
      };
    }

    const categories = monthlyData.map((m) => m.month);
    const series = durationKeys.map((d) => ({
      name: t(`trendDuration.durations.${d}`),
      data: monthlyData.map((m) => m[d]?.count || 0),
    }));

    return { categories, series, isEmpty: false };
  }, [data, t]);

  const options = {
    chart: {
      height: 350,
      type: "bar",
      stacked: true,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 6,
        dataLabels: { position: "top" },
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories,
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        formatter: (val) => (val ? `${val}` : ""),
      },
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      offsetY: 8,
    },
    fill: { opacity: 1 },
    colors: isEmpty
      ? ["#d3d3d3"]
      : [
        "#009298",
        "#71da61",
        "#003e70",
        "#f5b700",
        "#e4572e",
        "#669bbc",
        "#9c1de7",
        "#adb5bd",
      ],
    title: {
      text: t("trendDuration.title"),
      align: "center",
      style: { color: "#444" },
    },
  };

  return (
    <div>
      <h6 className="fw-bold mb-2" style={{ color: "#333" }}>
        {t("trendDuration.title")}
      </h6>

      <ReactApexChart options={options} series={series} type="bar" height={300} />

      {isEmpty && (
        <div className="text-center text-muted mt-2" style={{ fontSize: "14px" }}>
          {t("trendDuration.noData")}
        </div>
      )}
    </div>
  );
};

export default TrendDuration;
